import addRoute from '@/router/add-route';

const Transactions = () => import('@/modules/transactions/transactions.vue');
const TransactionDetails = () => import('@/modules/transactions/transaction-details.vue');
const DisputeForm = () => import('@/modules/transactions/dispute-form.vue');

const transactions = [
    addRoute({
        name: 'transactions',
        path: '/transactions',
        component: Transactions,
    }),
    addRoute({
        name: 'transaction-details',
        path: '/transactions/:id',
        component: TransactionDetails,
        root: {label: 'Lists', name: 'lists'},
    }),
    addRoute({
        name: 'add-dispute',
        path: '/transactions/dispute/add/:transactionId',
        component: DisputeForm,
        root: {label: 'Lists', name: 'lists'},
    }),
    addRoute({
        name: 'update-dispute',
        path: '/transactions/dispute/update/:id',
        component: DisputeForm,
        root: {label: 'Lists', name: 'lists'},
    }),
];

export default transactions;
